import { liveChangelistBaseQueryOptions } from "/app/src/routes/{-$locale}/index.tsx?tsr-shared=1";
const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { httpClient } from "@/lib/http-client";
import { getUpcoming } from "@/queries/upcoming";
import { getLatestOffers } from "@/queries/latest-offers";
import { getLatestReleased } from "@/queries/latest-released";
import { getStats } from "@/queries/stats";
import { historicalLowsQueryOptions } from "@/queries/historical-lows";
import { createFileRoute } from "@tanstack/react-router";
import { getGiveawaysStats } from "@/components/modules/giveaway-stats";
import { getBuilds } from "@/queries/get-builds";
import { mergeFreebies } from "@/utils/merge-freebies";
type LiveChangeAction = "insert" | "update" | "delete" | string;
type LiveChangeDelta = {
  changeType: LiveChangeAction;
  field: string;
  newValue: unknown;
  oldValue: unknown;
};
type LiveChangeContext = {
  _id?: string;
  id?: string;
  namespace?: string;
  title?: string;
  keyImages?: KeyImage[];
  offerType?: string;
  appName?: string;
  buildVersion?: string;
  name?: string;
};
type LiveChangeEvent = {
  _id: string;
  timestamp: string;
  metadata: {
    changes: LiveChangeDelta[];
    contextId: string;
    contextType: string;
    context?: LiveChangeContext | null;
  };
  __v?: number;
};
type PulseEvent = {
  id: string;
  timestamp: string;
  contextType: string;
  action: LiveChangeAction;
  badge: string;
  title: string;
  detail: string;
  changeCount: number;
  imageUrl?: string;
};
export const Route = createFileRoute("/{-$locale}/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    context
  }) => {
    const {
      queryClient,
      country
    } = context;
    await Promise.allSettled([queryClient.prefetchQuery({
      queryKey: ["giveaways"],
      queryFn: () => httpClient.get<GiveawayOffer[]>("/free-games", {
        params: {
          country
        }
      }).then(mergeFreebies).catch(() => [])
    }), queryClient.prefetchQuery({
      queryKey: ["upcoming", {
        country
      }],
      queryFn: () => getUpcoming({
        country: country ?? "US"
      }).catch(() => null),
      staleTime: 6000
    }), queryClient.prefetchQuery({
      queryKey: ["latest-games"],
      queryFn: () => getLatestOffers(country ?? "US").catch(() => [])
    }), queryClient.prefetchQuery({
      queryKey: ["latest-released", {
        country
      }],
      queryFn: () => getLatestReleased({
        country: country ?? "US"
      }).catch(() => ({
        elements: []
      }))
    }), queryClient.prefetchQuery({
      queryKey: ["stats", {
        country
      }],
      queryFn: () => getStats({
        country: country ?? "US"
      }).catch(() => null)
    }), queryClient.prefetchQuery({
      queryKey: ["giveaways-stats", {
        country
      }],
      queryFn: () => getGiveawaysStats({
        country: country ?? "US"
      }).catch(() => null)
    }), queryClient.prefetchQuery(historicalLowsQueryOptions(country ?? "US")), queryClient.prefetchQuery(liveChangelistBaseQueryOptions()), queryClient.prefetchQuery(getBuilds({
      sortDir: "desc",
      sortBy: "createdAt"
    }))]);
  }
});
type HoverCardType = "offer" | "build" | "none";